import React, { useState } from 'react';
import useApi from "../../lib/apiService.js";

function GroupSearch() {
	const [dealerIds, setDealerIds] = useState('');
	const [corgId, setCorgId] = useState('');
	const [filter, setFilter] = useState('');
	const [searching, setSearching] = useState(false);
	const [results, setResults] = useState([]);
	const [elapsed, setElapsed] = useState(null);
	const [error, setError] = useState(null);
	const [breakdown, setBreakdown] = useState({});
	const [groupName, setGroupName] = useState('');
	const [dealerNames, setDealerNames] = useState({});
	const Api = useApi();

	const handleLookupGroup = async () => {
		
		setError(null);
		if (!corgId.trim()) {
			setError('Please enter a CORG ID to lookup.');
			return;
		}
		try {
			const data = await Api.corgLookup(corgId.trim());
			if (data) {
				setGroupName(data.legalName ? data.legalName : '(No legalName found)');
				if (Array.isArray(data.children) && data.children.length > 0) {
					setDealerIds(data.children.join('\n'));
				} else {
					setError('No children found for this CORG ID.');
				}
			} else {
				setGroupName('(No legalName found)');
				setError('No group found for this CORG ID.');
			}
		} catch {
			setGroupName('(No legalName found)');
			setError('Error fetching group info.');
		}
	};

	const handleSearch = async () => {
		setSearching(true);
		setError(null);
		setResults([]);
		setElapsed(null);
		setBreakdown({});
		setDealerNames({});
		const ids = dealerIds.split('\n').map(id => id.trim()).filter(Boolean);
		if (ids.length === 0) {
			setError('Please enter at least one Common Org dealer ID.');
			setSearching(false);
			return;
		}
		const start = performance.now();
		// Use filter endpoint if filter is provided
		const allResults = await Promise.all(
			ids.map(async (id) => {
				try {
					const data = await Api.getCviVehiclesCoOrg(id, filter);
					return (data || []).map(v => ({
						vehicleId: v.id,
						vin: v.vin,
						entityId: v.entity_id || v.entityid || v.entityId,
						dealerId: id
					}));
				} catch {
					return [];
				}
			})
		);
		const flatResults = allResults.flat();
		setResults(flatResults);
		setElapsed(((performance.now() - start) / 1000).toFixed(2));
		// Build breakdown by dealerId
		const breakdownObj = {};
		ids.forEach(id => {
			breakdownObj[id] = flatResults.filter(r => r.dealerId === id).length;
		});
		setBreakdown(breakdownObj);
		// Lookup dealer names using corg-lookup
		const namesObj = {};
		await Promise.all(ids.map(async (id) => {
			try {
				const data = await Api.corgLookup(id);
				namesObj[id] = data && data.legalName ? data.legalName : '(No legalName found)';
			} catch {
				namesObj[id] = '(No legalName found)';
			}

			console.log(`Dealer ID: ${id}, Name: ${namesObj[id]}`);
		}));
		setDealerNames(namesObj);
		setSearching(false);
	};

	return (
		<div style={{ padding: 24 }}>
			<h2>Group Inventory Search</h2>
			<div style={{ marginBottom: 12 }}>
				<label htmlFor="corg-id">CORG ID (Group):</label>
				<div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
					<input
						id="corg-id"
						type="text"
						style={{ flex: 1 }}
						value={corgId}
						onChange={e => setCorgId(e.target.value)}
						placeholder="e.g. 1234abcd-5678-efgh-9012-ijklmnop3456"
					/>
					<button onClick={handleLookupGroup} style={{ padding: '8px 16px', fontSize: 14 }}>
						Lookup Group
					</button>
				</div>
			</div>
			{/* Show group name after group lookup, before dealer IDs textarea */}
			{groupName && (
				<div style={{ marginBottom: 12, fontWeight: 'bold' }}>
					Group Name: {groupName}
				</div>
			)}
			<label htmlFor="dealer-ids">Paste Common Org Dealer IDs (one per line):</label>
			<textarea
				id="dealer-ids"
				rows={8}
				style={{ width: '100%', marginBottom: 12 }}
				value={dealerIds}
				onChange={e => setDealerIds(e.target.value)}
				placeholder="e.g. 1234abcd-5678-efgh-9012-ijklmnop3456"
			/>
			<div style={{ marginBottom: 12 }}>
				<label htmlFor="filter-string">Custom Filter String (optional):</label>
				<input
					id="filter-string"
					type="text"
					style={{ width: '100%' }}
					value={filter}
					onChange={e => setFilter(e.target.value)}
					placeholder="e.g. and(gt(inventoryVehicle.prices.listPrice.value,10000),lt(inventoryVehicle.prices.listPrice.value,20000))"
				/>
			</div>
			<button onClick={handleSearch} disabled={searching} style={{ padding: '8px 24px', fontSize: 16 }}>
				{searching ? 'Searching...' : 'Search'}
			</button>
			{elapsed && (
				<div style={{ marginTop: 18, fontWeight: 'bold' }}>
					Search completed in {elapsed} seconds
				</div>
			)}
			{results.length > 0 && (
				<div style={{ marginTop: 8, fontWeight: 'bold' }}>
					Total vehicles returned: {results.length}
					<div style={{ marginTop: 6, fontWeight: 'normal' }}>
						<table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 8 }}>
							<thead>
								<tr style={{ background: '#eee' }}>
									<th style={{ border: '1px solid #ccc', padding: 8 }}>Store Name</th>
									<th style={{ border: '1px solid #ccc', padding: 8 }}>Vehicle Count</th>
								</tr>
							</thead>
							<tbody>
								{Object.entries(breakdown).map(([id, count]) => (
									<tr key={id}>
										<td style={{ border: '1px solid #ccc', padding: 8 }} title={id}>
											{dealerNames[id] && dealerNames[id] !== '(No legalName found)' ? dealerNames[id] : <span style={{ color: '#888' }}>{id}</span>}
										</td>
										<td style={{ border: '1px solid #ccc', padding: 8 }}>{count}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			)}
			{error && (
				<div style={{ color: 'red', marginTop: 12 }}>{error}</div>
			)}
			{results.length > 0 && (
				<table style={{ width: '100%', marginTop: 24, borderCollapse: 'collapse' }}>
					<thead>
						<tr style={{ background: '#eee' }}>
							<th style={{ border: '1px solid #ccc', padding: 8 }}>Vehicle ID</th>
							<th style={{ border: '1px solid #ccc', padding: 8 }}>VIN</th>
							<th style={{ border: '1px solid #ccc', padding: 8 }}>Entity ID</th>
							<th style={{ border: '1px solid #ccc', padding: 8 }}>Dealer ID</th>
						</tr>
					</thead>
					<tbody>
						{results.map((row, idx) => (
							<tr key={row.vehicleId + row.dealerId + idx}>
								<td style={{ border: '1px solid #ccc', padding: 8 }}>{row.vehicleId}</td>
								<td style={{ border: '1px solid #ccc', padding: 8 }}>{row.vin}</td>
								<td style={{ border: '1px solid #ccc', padding: 8 }}>{row.entityId}</td>
								<td style={{ border: '1px solid #ccc', padding: 8 }}>{row.dealerId}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	);
}

export default GroupSearch;
// This file should be moved from src/ to components/.
// Please copy the contents from src/GroupSearch.js here.
